import Dyngraph2PNG from '../Components/Dyngraph2PNG';
import {fetchJSON, fetchPOST, QueryString} from '../Tools';
import * as routes from './Routes';

const GRAPH_HEIGHT = 440;

const colorPrognoseBG = 'rgba(222,226,238,0.6)'; // Hintergrundfarbe Prognose
const colorPrognose = 'rgb(243,147,19)'; // Prognose
const colorTemp = 'rgb(190,10,10)'; // Dunkles Rot für Lufttemperatur
const colorSR = 'rgb(0,0,128)'; // Schutzraum
const colorOL = 'rgb(128,0,0)'; // Orientierungslinie
const colors = {
    Sm: [
        {
            value: 1.5,
            color: 'rgb(37,64,143)',
            text: 'sehr nass',
        }, // Nass
        {
            value: 1.2,
            color: 'rgb(135,149,193)',
            text: 'etwas zu nass',
        }, // etwas nass
        {
            value: 0.8,
            color: 'rgb(0,123,124)',
            text: 'durchschnittlich',
        }, // mittel
        {
            value: 0.5,
            color: 'rgb(255,204,0)',
            text: 'etwas zu trocken',
        }, // etwas zu trocken
        {
            value: 0.0,
            color: 'rgb(190,15,63)',
            text: 'sehr trocken',
        }, // sehr trocken
    ],
    colorDefault: 'rgb(37,64,143)',
    mondayLongTimes: 'rgb(243,147,19)',
};

export default class Graph {
    protected graphContainer: NodeListOf<HTMLDivElement>;
    protected colorDefault = 'rgb(37,64,143)'; // Dunkles Blau: @base-dark-color #25408f
    protected graphs: Array<IGraphContainer> = [];
    protected colorPrognose = 'rgb(243,147,19)';

    constructor() {

        const _this = this;
        _this.graphContainer = document.querySelectorAll('.rw-graph');
        if (!_this.graphContainer.length) {
            return;
        }
        _this.initGraph();
    }

    initGraph() {
        const _this = this;
        // nee width
        let width = 0;
        _this.graphContainer.forEach(async (graphContainer, index) => {
            let gItem: IGraphContainer = {
                graphs: [],
                tabItems: [],
            };

            if (width === 0 && parseInt(window.getComputedStyle(graphContainer).width) > 100) {
                width = parseInt(window.getComputedStyle(graphContainer).width);
            }
            if (width === 0) {
                width = graphContainer.closest('.reportwesen-card').getBoundingClientRect().width - 60;
            }

            let jsonURL = graphContainer.dataset.graph;
            let graphData: any;
            if (jsonURL.match('/?ajax')) {
                graphData = await fetchJSON(jsonURL);
            } else {
                graphData = await fetchJSON('/reportwesen/data/' + jsonURL);
            }
            if (!graphData.properties) {
                return;
            }

            const ev = new CustomEvent('graphDataLoaded', {detail: graphData});
            window.dispatchEvent(ev);
            if (!graphData.properties.stationName) {
                graphContainer.querySelectorAll('.loading-info').forEach((el) => {
                    el.remove();
                });
                this.showNoDataInfo(graphContainer);
                return;
            }
            // tabContainer
            let tabContainer = document.createElement('div');
            tabContainer.classList.add('dia-tabs');
            tabContainer.classList.add('tabs-' + Object.keys(graphData).length);
            tabContainer.setAttribute('role', 'tabpanel');
            let tabList = document.createElement('ul');
            tabList.className = 'nav nav-tabs';
            tabList.setAttribute('role', 'tablist');
            tabContainer.insertAdjacentElement('afterbegin', tabList);
            for (let tab in graphData) {
                if (tab === 'properties') {
                    continue;
                }
                if (!graphData[tab]['data']) {
                    console.debug('no data for ' + tab);
                    continue;
                }
                let tabItem = document.createElement('li');
                let tabId = 'g-' + index + '-' + tab;
                tabItem.setAttribute('role', 'presentation');

                let tabLink = document.createElement('a');
                tabLink.href = '#';
                tabLink.setAttribute('role', 'tab');
                tabLink.innerText = tab;
                tabLink.addEventListener('click', (ev) => {
                    ev.preventDefault();
                    return false;
                });

                let warnings = graphData[tab]['warnings'];
                let areas = graphData[tab]['areas'];
                tabItem.insertAdjacentElement('beforeend', tabLink);
                tabList.insertAdjacentElement('beforeend', tabItem);
                let graphTab = document.createElement('div');
                graphTab.id = tabId;
                tabItem.dataset.tab = tabId;
                graphTab.classList.add('rw-graph-inner');
                graphContainer.insertAdjacentElement('afterbegin', graphTab);
                let calcMinMax = _this.getMinMax(graphData[tab]['data'], warnings, tab, areas);
                let unit = graphData[tab]['unit'];
                let graphSeriesData = {};
                let labels = graphData[tab]['lines'];
                labels.forEach((lbl) => {
                    graphSeriesData[lbl] = {
                        color: _this.colorDefault,
                        unit: unit ? unit : 'nothing',
                        xRangePad: 0,
                        defaultLegendValue: '-',
                        legend: graphData[tab].labels ? graphData[tab].labels[lbl] : lbl,
                    };

                    switch (lbl) {
                        case 'Prognose':
                            graphSeriesData['Prognose'] = {
                                color: _this.colorPrognose,
                                plotter: _this.graphPrognoseLinePlotter,
                                connectSeparatedPoints: false,
                                strokeWidth: 2,
                                unit: unit,
                                defaultLegendValue: '-',
                                legend: 'Vorhersage',
                                last: graphData[tab]['last'],
                            };
                            break;
                        case 'Niederschlag':
                            graphSeriesData['Niederschlag'] = {
                                plotter: _this.barChartPlotter,
                                // color: _this.colorDefault,
                                unit: unit,
                                xRangePad: (400 / (graphData[tab]['data'].length * 1.2)) * 2,
                                defaultLegendValue: '0',
                                legend: 'Niederschlag',
                                rangeSelectorAlpha: 1.0,
                            };
                            break;
                        case 'Vorhersage':
                            graphSeriesData['Vorhersage'] = {
                                plotter: _this.barChartPlotter,
                                color: _this.colorPrognose,
                                unit: unit,
                                xRangePad: (400 / (graphData[tab]['data'].length * 1.2)) * 2,
                                yRangePad: 200,
                                defaultLegendValue: '0',
                                legend: 'Vorhersage',
                            };
                            break;
                        case 'Schutzraum':
                            graphSeriesData[lbl]['color'] = colorSR;
                            break;
                        case 'Orientierungslinie':
                            graphSeriesData[lbl]['color'] = colorOL;
                            break;
                        case 'Lufttemperatur':
                            graphSeriesData[lbl]['color'] = colorTemp;
                            break;
                        default:
                    }
                });
                if (graphData[tab]['stationName']) {
                    const titleEl = graphContainer.closest('.row').querySelector('.rw-station-name');
                    titleEl ? (titleEl.textContent = graphData[tab]['stationName']) : false;
                } else if (graphData[tab]['labels']) {
                    let stationNameDiv = graphContainer.closest('.row').querySelector('.rw-station-name');
                    let labelKeys = Object.keys(graphData[tab]['labels']);
                    stationNameDiv.textContent = '';
                    labelKeys.forEach((element, index) => {
                        stationNameDiv.textContent += graphData[tab]['labels'][element];
                        if (index < labelKeys.length - 1) {
                            stationNameDiv.textContent += ', ';
                        }
                    });
                }

                let legendContainer = _this.createTabLabelContainer(tab, graphSeriesData);
                // Graph erzeugen
                // Keine Daten vorhanden
                let dynGraph = null;
                if (graphData[tab]['data'].length > 0) {
                    dynGraph = new window.Dygraph(graphTab, graphData[tab]['data'], {
                        underlayCallback: function (canvas: CanvasRenderingContext2D, area: IGraphArea, g: any) {
                            if (warnings !== undefined) {
                                _this.dyDrawWarnings(canvas, area, g, warnings, false, graphData[tab]['unit']);
                            }
                            if (graphData[tab]['areas'].length) {
                                _this.dyDrawAreas(canvas, area, g, graphData[tab]['areas']);
                            }
                        },
                        animatedZooms: true,
                        xRangePad: graphSeriesData[tab] ? graphSeriesData[tab].xRangePad : 0,
                        legend: 'always',
                        valueRange: [calcMinMax.min, calcMinMax.max],
                        height: GRAPH_HEIGHT,
                        width: width,
                        labels: labels,
                        highlightSeriesOpts: {
                            strokeWidth: 2,
                            strokeBorderWidth: 1,
                            highlightCircleSize: 3,
                        },
                        pointSize: 1,
                        drawPoints: false,
                        connectSeparatedPoints: true,
                        drawGapEdgePoints: false,
                        xAxisHeight: 50,
                        pixelsPerLabel: 40,
                        drawAxesAtZero: false,
                        interactionModel: {}, // ZOOM deaktiviert
                        gridLineWidth: 0.6,
                        labelsSeparateLines: false,
                        showLabelsOnHighlight: true,
                        hideOverlayOnMouseOut: false,
                        labelsDivWidth: 0,
                        series: graphSeriesData,
                        axes: {
                            y: {
                                axisLabelWidth: 30,
                                valueFormatter: function (num_or_millis: number, opts: any, seriesName: string, dynGraph, row, col) {
                                    _this.evLegendValueUpdater(
                                        graphData[tab]['data'][row][col],
                                        opts('series')[seriesName]['unit'],
                                        dynGraph.highlightSet_,
                                        graphContainer,
                                        tab,
                                        graphSeriesData,
                                        graphData[tab]['data'][row]
                                    );
                                    return num_or_millis.toFixed(2);
                                },
                            },
                            x: {
                                axisLabelWidth: 40,
                                ticker: (min: number, max: number, pixels) => {
                                    let tickValues = new Array();
                                    let hDiff = parseInt(((max - min) / (60 * 60)).toFixed(0));
                                    let mod = 24 * 60 * 60; // default 24 Stunden Takt

                                    if (hDiff < 72) {
                                        mod = 6 * 60 * 60; // 6 Stunden Takt
                                    }
                                    if (hDiff <= 24) {
                                        mod = 4 * 60 * 60; // Stundentakt
                                    }
                                    if (hDiff <= 12) {
                                        mod = 30 * 60; // 30 Minuten
                                    }
                                    if (hDiff <= 4) {
                                        mod = 10 * 60; // 10 Minuten
                                    }
                                    if (hDiff > 1000) {
                                        // Montagsbericht hDiff / 300 Tage
                                        mod = parseInt((hDiff / 300).toFixed(0)) * (24 * 60 * 60);
                                    }
                                    max = parseInt(max.toFixed(0));
                                    let startTS = parseInt((_this.zeroDay(new Date(min * 1000)).getTime() / 1000).toFixed(0));
                                    if (pixels < 400) {
                                        mod *= 3;
                                    }
                                    while (startTS <= max) {
                                        const date = new Date(startTS * 1000);
                                        const tickDate = date.toLocaleString('de-DE', {
                                            month: '2-digit',
                                            day: '2-digit',
                                        });
                                        const tickTime = date.toLocaleString('de-DE', {
                                            hour: '2-digit',
                                            minute: '2-digit',
                                        });
                                        const t = {
                                            v: startTS,
                                            label: '<span class="dia-date" style="font-weight: bold">' + tickDate + '</span><br /><span class="dia-time">' + tickTime + '</span>',
                                        };
                                        tickValues.push(t);
                                        startTS += mod;
                                    }
                                    return tickValues;
                                },
                                valueFormatter: (ts: number) => {
                                    _this.evLegendTimeUpdater(ts, legendContainer);
                                },
                            },
                        },
                    });
                    dynGraph.warnings = warnings;
                    dynGraph.areas = areas;
                    let dx = new Dyngraph2PNG(dynGraph, {fontSize: 16});
                    const m = location.href.match(/show=(\d+)/);
                    if (m?.length > 1) {
                        fetchPOST(routes.RWGExport, {
                            data: dx.image.src,
                            id: m[1],
                            hash: jsonURL + dynGraph.maindiv_.id,
                        });
                    }

                    graphTab.insertAdjacentElement('beforeend', legendContainer);
                    gItem.graphs.push(dynGraph);
                    const dt = new Date();
                    dt.setDate(dt.getDate() - 1);
                    if (graphData[tab].last < dt.getTime() / 1000) {
                        const hintDiv = document.createElement('div');
                        hintDiv.classList.add('graph-hint');
                        hintDiv.innerHTML = '<i class="icon-exclamation"></i> Daten älter als 24h';
                        graphTab.insertAdjacentElement('afterbegin', hintDiv);
                        graphTab.classList.add('margin-hint');
                        graphTab.style.marginTop = '1.8em"';
                    }
                } else {
                    this.showNoDataInfo(graphTab);
                }
                gItem.tabItems.push(tabItem);
                _this.graphs.push(gItem);

                tabItem.addEventListener('click', () => _this.onTabSelect(tabItem, gItem));
                if (dynGraph) {
                    // init legend with first value
                    _this.initLegend(graphSeriesData, graphData, tab, graphContainer, legendContainer);
                    // init zoom container
                    _this.initZoom(dynGraph, graphTab);
                    if (calcMinMax.diff === 1 || calcMinMax.zoomY) {
                        // diff less 1 click zoom-Y by default
                        const ev = new Event('click');
                        graphTab.querySelector('.rw-graph-zoom-Y a').dispatchEvent(ev);
                    }
                }
                // remove inline styles from dygraph
                graphTab.style.height = '';
                graphTab.style.width = '';
            }
            graphContainer.insertAdjacentElement('afterbegin', tabContainer);
            _this.onTabSelect(gItem.tabItems[0], gItem);
            graphContainer.querySelectorAll('.loading-info').forEach((el) => {
                el.remove();
            });
        });

        document.addEventListener('onBarAccordionToggle', (ev: CustomEvent) => {
            if (ev.detail.expanded) {
                _this.graphs.forEach((gItem) => {
                    gItem.graphs.forEach((g) => {
                        g.resize(g.graphDiv.closest('.graph-container').offsetWidth, GRAPH_HEIGHT);
                    });
                });
            }
        });
        window.addEventListener('resize', (ev: CustomEvent) => {
            _this.graphs.forEach((gItem) => {
                gItem.graphs.forEach((g) => {
                    g.resize(g.graphDiv.closest('.graph-container').offsetWidth, GRAPH_HEIGHT);
                });
            });
        });
    }

    showNoDataInfo(graphTab: HTMLDivElement) {
        let noDataDiv = document.createElement('div');
        noDataDiv.classList.add('graph-empty');
        noDataDiv.textContent = 'Keine Daten vorhanden';
        graphTab.insertAdjacentElement('afterbegin', noDataDiv);
    }

    /**
     * set initial values for legend
     * @param graphSeriesData
     * @param graphData
     * @param tab
     * @param graphContainer
     * @param legendContainer
     */
    initLegend(graphSeriesData, graphData, tab, graphContainer, legendContainer) {
        const _this = this;
        let labelIndex = 0;
        for (let label in graphSeriesData) {
            if (label !== 'time') {
                _this.evLegendValueUpdater(
                    graphData[tab]['data'][0][labelIndex] || null,
                    graphSeriesData[label]['unit'],
                    label,
                    graphContainer,
                    tab,
                    graphSeriesData,
                    graphData[tab]['data'][0]
                );
                if (label === 'Niederschlag') {
                    _this.evLegendValueUpdater(
                        graphData[tab]['data'][0][labelIndex] || null,
                        graphSeriesData[label]['unit'],
                        'Prognose',
                        graphContainer,
                        tab,
                        graphSeriesData,
                        graphData[tab]['data'][0]
                    );
                }
            } else {
                _this.evLegendTimeUpdater(graphData[tab]['data'][0][0], legendContainer);
            }
            labelIndex++;
        }
    }

    /**
     * write label, unit and value in legend
     * @param num_or_millis
     * @param unit
     * @param seriesName
     * @param graphContainer
     * @param tab
     */
    evLegendValueUpdater(num_or_millis: number, unit: string, seriesName: string, graphContainer: HTMLElement, tab: string, graphSeriesData, rowData: Array<number>) {
        const _this = this;
        graphContainer.querySelectorAll('.rw-graph-legend-value').forEach((el) => {
            el.classList.remove('active');
        });
        let col = 0;
        for (let seriesKey in graphSeriesData) {
            let sName = seriesKey;
            const seriesArrayName = sName;
            if (sName !== 'time') {
                let legendValueDiv = graphContainer.querySelector('.rw-graph-legend-' + tab + '-' + sName);
                if (seriesName === sName) {
                    legendValueDiv.classList.add('active');
                } else {
                    legendValueDiv.classList.remove('active');
                }
                if (rowData.length > col) {
                    let displayValue = 0;
                    if (rowData[col] !== null) {
                        displayValue = rowData[col];
                    }
                    legendValueDiv.innerHTML = '<i class="icon-right-dir"></i> ' + sName + ' [' + graphSeriesData[seriesArrayName].unit + ']: ' + displayValue.toFixed(2);
                } else {
                    if (legendValueDiv.innerHTML === '') {
                        legendValueDiv.innerHTML =
                            '<i class="icon-right-dir"></i> ' + graphSeriesData[seriesArrayName].legend + ' [' + unit + ']: ' + graphSeriesData[seriesArrayName].defaultLegendValue;
                    }
                }
            }
            col++;
        }
    }

    /**
     * write date and time in legend
     * @param ts
     * @param legendContainer
     */
    evLegendTimeUpdater(ts: number, legendContainer: HTMLElement) {
        const date = new Date(ts * 1000);
        let strMonth = (date.getMonth() + 1 < 10 ? '0' : '') + (date.getMonth() + 1);
        let strDay = (date.getDate() < 10 ? '0' : '') + date.getDate();
        let strHour = (date.getHours() < 10 ? '0' : '') + date.getHours();
        let strMin = (date.getMinutes() < 10 ? '0' : '') + date.getMinutes();
        let strSec = (date.getSeconds() < 10 ? '0' : '') + date.getSeconds();
        let retVal =
            '<div class="legendTime pull-left" style="width:12em;">' + strDay + '.' + strMonth + '.' + date.getFullYear() + ' ' + strHour + ':' + strMin + ':' + strSec + '</div>';
        legendContainer.querySelector('.rw-graph-legendTime').innerHTML = retVal;
    }

    /**
     * Creates legendContainer for current tab
     * @param tab
     * @param graphSeriesData
     * @returns
     */
    createTabLabelContainer(tab: string, graphSeriesData: IDictionary) {
        let legendContainer = document.createElement('div');
        legendContainer.classList.add('rw-graph-legend');
        let legendTimeDiv = document.createElement('div');
        legendTimeDiv.classList.add('rw-graph-legendTime');

        for (let label in graphSeriesData) {
            if (label !== 'time') {
                let legendValueDiv = document.createElement('div');
                legendValueDiv.classList.add('rw-graph-legend-' + tab + '-' + label);
                legendValueDiv.classList.add('rw-graph-legend-color-' + label);
                legendValueDiv.classList.add('rw-graph-legend-value');
                legendContainer.insertAdjacentElement('beforeend', legendValueDiv);
                if (label === 'Niederschlag') {
                    let legendPrognoseDiv = document.createElement('div');
                    legendPrognoseDiv.classList.add('rw-graph-legend-' + tab + '-Prognose');
                    legendPrognoseDiv.classList.add('rw-graph-legend-value');
                    legendPrognoseDiv.classList.add('rw-graph-legend-color-Prognose');
                    legendContainer.insertAdjacentElement('beforeend', legendPrognoseDiv);
                }
            }
        }
        legendContainer.insertAdjacentElement('afterbegin', legendTimeDiv);
        return legendContainer;
    }

    /**
     * return today with 00:00:00
     * @param date
     * @returns date
     */
    zeroDay(date) {
        date.setHours(0);
        date.setMinutes(0);
        date.setSeconds(0);
        return date;
    }

    /**
     * Aktiven Graph über tabs wechseln
     * @param activeTab
     * @param gItem
     */
    onTabSelect(activeTab, gItem: IGraphContainer) {
        gItem.tabItems.forEach((tabItem) => {
            tabItem.classList.remove('active');
            document.getElementById(tabItem.dataset.tab).classList.add('d-none');
        });
        activeTab.classList.add('active');
        document.getElementById(activeTab.dataset.tab).classList.remove('d-none');
        gItem.graphs.forEach((g) => {
            g.resize(g.graphDiv.closest('.graph-container').offsetWidth, GRAPH_HEIGHT);
        });
    }

    /**
     * Horizontale Linie für Warnstufen
     * @param canvas
     * @param area
     * @param g
     * @param warnings
     * @param infoLine
     */
    dyDrawWarnings(canvas: CanvasRenderingContext2D, area: IGraphArea, g: any, warnings: IDictionary, infoLine: boolean, unit?: string) {
        const colors = {
            warnings: {
                0: ['rgb(228,205,26)', 'Hochwasserwarnung'],
                1: ['rgb(255,0,26)', 'Hochwassereinsatz'],
                2: ['rgb(255,0,26)', 'Hochwasseralarm'],
                3: ['rgb(37,64,143)', 'TODO: 1635227478'],
                Hochwasserwarnung: 'rgb(228,205,26)',
                Hochwassereinsatz: 'rgb(255,0,26)',
                Hochwasseralarm: 'rgb(255,0,26)',
            },
        };
        let i = 0;
        for (let warning in warnings) {
            // Selecting a date in the middle of the graph.
            let splitDate = new Date().getTime();
            let coords = g.toDomCoords(splitDate, warnings[warning]);
            if (infoLine) {
                canvas.fillStyle = '#25408f';
            } else {
                if (colors.warnings[warning]) {
                    canvas.fillStyle = colors.warnings[warning];
                } else {
                    canvas.fillStyle = colors.warnings[i][0];
                }
            }
            canvas.fillRect(area.x, coords[1], area.w, 1);
            canvas.font = '12px Arial';
            let label = warning; // colors.warnings[i][1];
            if (label.match(/^Warnstufe/)) {
                label = label.replace('Warnstufe', 'Meldestufe');
            }
            if (unit) {
                label += ' - ' + warnings[warning] + ' ' + unit;
            }
            canvas.fillText(label, area.x + 5, coords[1] - 2);
            i++;
        }
    }

    hexToRgb(hex: string, alpha: number = null) {
        hex = hex.replace('#', '');
        const r = parseInt(hex.length == 3 ? hex.slice(0, 1).repeat(2) : hex.slice(0, 2), 16);
        const g = parseInt(hex.length == 3 ? hex.slice(1, 2).repeat(2) : hex.slice(2, 4), 16);
        const b = parseInt(hex.length == 3 ? hex.slice(2, 3).repeat(2) : hex.slice(4, 6), 16);
        if (alpha) {
            return 'rgba(' + r + ', ' + g + ', ' + b + ', ' + alpha + ')';
        } else {
            return 'rgb(' + r + ', ' + g + ', ' + b + ')';
        }
    }

    invertColor(hex: string, bw: boolean = true) {
        hex = hex.replace('#', '');
        // convert 3-digit hex to 6-digits.
        if (hex.length === 3) {
            hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
        }
        if (hex.length !== 6) {
            throw new Error('Invalid HEX color: ' + hex);
        }
        let r = parseInt(hex.slice(0, 2), 16),
            g = parseInt(hex.slice(2, 4), 16),
            b = parseInt(hex.slice(4, 6), 16);
        if (bw) {
            // https://stackoverflow.com/a/3943023/112731
            return r * 0.299 + g * 0.587 + b * 0.114 > 186 ? '#000000' : '#FFFFFF';
        }
        // pad each with zeros and return
        return '#' + this.padZero((255 - r).toString(16)) + this.padZero((255 - g).toString(16)) + this.padZero((255 - b).toString(16));
    }

    padZero(str, len = null) {
        len = len || 2;
        var zeros = new Array(len).join('0');
        return (zeros + str).slice(-len);
    }

    dyDrawAreas(canvas, area, g, diagramAreas) {
        const yRange = g.yAxisRange();

        diagramAreas.forEach((diagramArea, index) => {
            if (index === 0 || diagramArea.min_y < yRange[1]) {
                const minY = g.toDomYCoord(parseFloat(diagramArea.min_y));
                const maxY = g.toDomYCoord(parseFloat(diagramArea.max_y));

                canvas.fillStyle = this.hexToRgb(diagramArea.style, 0.5);
                canvas.fillRect(area.x, maxY, area.w, minY - maxY);
                canvas.fillStyle = this.invertColor(diagramArea.style, true);
                canvas.font = 'small-caps bold 15px Arial';
                canvas.fillText(diagramArea.label, area.x + 5, Math.max(area.y, maxY) + 16);
            }
        });
    }

    /**
     * Berechnet min/max neu
     * Warnungen werden berücksichtigt
     *
     * @param warnings
     * @param min
     * @param max
     * @returns
     */
    getMinMax(graphData, warnings: IDictionary, debug = null, areas = null) {
        // remove NULL values
        graphData = graphData
            .map(function (o) {
                return o
                    .map(function (i) {
                        return i;
                    })
                    .filter(function (val) {
                        return val !== null;
                    });
            })
            .filter(function (val) {
                return val !== null;
            });

        let graphMax = <number>Math.max.apply(
            Math,
            graphData.map(function (o) {
                let copy = Array.from(o);
                copy.shift();
                return Math.max.apply(null, copy);
            })
        );
        let graphMin = <number>Math.min.apply(
            null,
            graphData.map(function (o) {
                let copy = Array.from(o);
                copy.shift();
                return Math.min.apply(null, copy);
            })
        );

        if (warnings) {
            for (let warning in warnings) {
                if (parseFloat(warnings[warning]) > graphMax) {
                    graphMax = parseFloat(warnings[warning]);
                    graphMax += (graphMax / 100) * 20;
                }
            }
        }

        if (areas) {
            for (let area in areas) {
                if (areas[area].max_y && parseFloat(areas[area].max_y) > graphMax && parseFloat(areas[area].max_y) < graphMax * 1.5) {
                    graphMax = parseFloat(areas[area].max_y);
                    graphMax += (graphMax / 100) * 20;
                }
            }
        }

        const minPoint = graphMin;
        const maxPoint = graphMax;
        let diff = (graphMax - graphMin) * 0.2;

        if (graphMin - diff > 0) {
            graphMin -= diff;
        } else {
            diff = graphMin * 0.2;
        }

        const zoomY = diff < 2 ? true : false;
        // graphMax = zoomY ? (minPoint + maxPoint < graphMax ? graphMax + diff : minPoint + maxPoint) : graphMax + diff;
        graphMax += diff;
        // graphMax = graphMax + diff;
        // graphMin = zoomY ? 0 : graphMin;

        const DEBUG = QueryString['debug'] === '1';

        if (DEBUG) {
            console.log({
                debug: minPoint + maxPoint,
                minPoint: minPoint,
                maxPoint: maxPoint,
                min: graphMin,
                max: graphMax,
                diff: diff,
                zoomY: zoomY,
            });
        }
        return {
            minPoint: minPoint,
            maxPoint: maxPoint,
            min: graphMin,
            max: graphMax,
            diff: diff,
            zoomY: zoomY,
        };
    }

    /**
     * fit to min/max
     * @param g
     */
    initZoom(dynGraph: any, graphContainer: HTMLElement) {
        const _this = this;

        let zoomContainer = document.createElement('div');
        zoomContainer.classList.add('rw-graph-zoom');
        zoomContainer.classList.add('gradient-border');
        graphContainer.insertAdjacentElement('beforeend', zoomContainer);
        let zoomButtons = [
            {class: 'rw-graph-zoom-Y rw-button', text: 'Zoom-Y', days: false},
            {class: 'rw-graph-info', text: 'Zeitraum'},
            {class: 'rw-graph-zoom-7 rw-button rw-time-button active', text: '7-Tage', days: 7},
            {class: 'rw-graph-zoom-3 rw-button rw-time-button', text: '3-Tage', days: 3},
            {class: 'rw-graph-zoom-1 rw-button rw-time-button', text: '1-Tag', days: 1},
        ];

        let dtLast = new Date(dynGraph.rawData_[dynGraph.rawData_.length - 1][0] * 1000);
        zoomButtons.forEach((zoomData: IDictionary) => {
            let el = document.createElement('div');
            el.className = zoomData.class;
            if (el.classList.contains('rw-button')) {
                el.dataset.days = zoomData.days;
                if (zoomData.days) {
                    let dtMin = new Date(dynGraph.rawData_[0][0] * 1000);
                    let hours = Math.abs(dtLast.getTime() - dtMin.getTime()) / 36e5;
                    if (hours / 24 < zoomData.days) {
                        // Weniger als Tag für den Button = ausblenden
                        // el.classList.add('hidden');
                        // oder entfernen
                        // return;
                    }
                }
                let zoomLink = document.createElement('a');
                zoomLink.innerText = zoomData.text;
                zoomLink.href = '#';
                zoomLink.addEventListener('click', (ev) => {
                    ev.preventDefault();
                    _this.evZoom(el, dynGraph);
                });
                el.insertAdjacentElement('afterbegin', zoomLink);
            } else {
                el.innerText = zoomData.text;
            }
            zoomContainer.insertAdjacentElement('beforeend', el);
        });
        if (!zoomContainer.querySelectorAll('.rw-time-button').length) {
            zoomContainer.querySelector('.rw-graph-info').remove();
        }
        _this.evSetZoom(dynGraph, false);
    }

    /**
     * calculate start/end/zoomY and zoom in/out
     * @param dynGraph
     * @param zoomByGraph if set, dyngraph calc min/max values for Y-Axis
     * @param days visible days, default 7
     */
    evSetZoom(dynGraph, zoomByGraph = true, days = 7) {
        const _this = this;
        let dateWindow = null;

        if (days !== 7) {
            let lastTs = dynGraph.rawData_[dynGraph.rawData_.length - 1][0];
            let dateStart = new Date();
            dateStart.setDate(dateStart.getDate() - days);
            let tsStart = dateStart.getTime() / 1000;
            dateWindow = [tsStart, lastTs];
        }

        if (zoomByGraph) {
            // von dyngraph berechnete werte
            dynGraph.updateOptions({
                dateWindow: dateWindow,
                valueRange: null,
            });
        } else {
            // selbst berechnete werte
            let minMax = _this.getMinMax(dynGraph.rawData_, dynGraph.warnings, false, dynGraph.areas);
            dynGraph.updateOptions({
                dateWindow: dateWindow,
                valueRange: [minMax.min, minMax.max],
            });
        }
    }

    /**
     * click in Zoom-Container
     * @param el
     * @param dynGraph
     */
    evZoom(el: HTMLElement, dynGraph: any) {
        const _this = this;
        let zoomY = el.parentElement.querySelector('.rw-graph-zoom-Y');
        if (el.classList.contains('rw-graph-zoom-Y')) {
            el.classList.toggle('active');
            let activeDays: HTMLElement = el.parentElement.querySelector('.rw-time-button.active');
            _this.evSetZoom(dynGraph, el.classList.contains('active'), activeDays ? parseInt(activeDays.dataset.days) : 7);
        } else {
            el.parentElement.querySelector('.rw-time-button.active').classList.remove('active');
            el.classList.add('active');
            _this.evSetZoom(dynGraph, zoomY.classList.contains('active'), parseInt(el.dataset.days));
        }
    }

    /**
     * Prognose-Plotter
     * @param plotterObject
     */
    graphPrognoseLinePlotter(plotterObject: IPlotterGraphObject) {
        const ctx = plotterObject.drawingContext;
        const dtNow = <number>plotterObject.dygraph.attributes_.series_.Prognose.options.last;
        ctx.strokeStyle = plotterObject.color;
        ctx.beginPath();
        // ctx.fillStyle = colorPrognose;
        ctx.moveTo(plotterObject.points[0].canvasx, plotterObject.points[0].canvasy);
        let px = new Array();
        for (var i = 1; i < plotterObject.points.length; i++) {
            if (!isNaN(plotterObject.points[i].canvasy)) {
                if (plotterObject.points[i + 1]?.xval >= dtNow) {
                    ctx.lineTo(plotterObject.points[i].canvasx, plotterObject.points[i].canvasy);
                    px.push(plotterObject.points[i].canvasx);
                }
            }
        }
        ctx.stroke();
        // Prognose mit Hintergrundfarbe
        ctx.beginPath();
        ctx.fillStyle = colorPrognoseBG;
        ctx.fillRect(px[0] - 1, 0, plotterObject.plotArea.w, plotterObject.plotArea.h + plotterObject.plotArea.y - 1);
    }

    /**
     * Plotter für Balken (Bars)
     * @param {IPlotterGraphObject} plotterObject context
     */
    barChartPlotter(plotterObject: IPlotterGraphObject) {
        let ctx = plotterObject.drawingContext;
        let points = plotterObject.points;
        let y_bottom = plotterObject.dygraph.toDomYCoord(0);
        let today = new Date();
        today.setHours(0, 0, 0, 0);

        let bar_width = ctx.canvas.width / points.length / 3;
        if (ctx.canvas.style.width !== '100%' && parseInt(ctx.canvas.style.width) < 600) {
            bar_width = 10;
        }
        for (let i = 0; i < points.length; i++) {
            if (plotterObject.setName === 'Vorhersage') {
                if ((<any>plotterObject.allSeriesPoints)[0][i].yval === (<any>plotterObject.allSeriesPoints)[1][i].yval) {
                    continue;
                }
                if ((<any>plotterObject.allSeriesPoints)[1][i].yval > 0) {
                    // set bottom position to top of niederschlag position
                    y_bottom = (<any>plotterObject.allSeriesPoints)[0][i].canvasy;
                }

                ctx.fillStyle = colorPrognose;
                ctx.fillRect(points[i].canvasx - bar_width / 2, points[i].canvasy, bar_width, y_bottom - points[i].canvasy);
            } else {
                ctx.fillStyle = colors.colorDefault;
                ctx.fillRect(points[i].canvasx - bar_width / 2, points[i].canvasy, bar_width, y_bottom - points[i].canvasy);
            }
        }
    }
}
